module.exports = __webpack_public_path__ + "img/ikon_sal.5d42254f.svg";